import clsx from 'clsx'
import update from 'immutability-helper'
import React from 'react'
import FormGroup from '@mui/material/FormGroup'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

export default function CheckboxChoice ({context, question, choices}) {
  
  const [options, setOptions] = React.useState(choices.map(choice => ({...choice})))

  function handleChange(index, checked) {
    const updatedOptions = update(options, {[index]: {correct: {$set: checked}}})
    setOptions(updatedOptions)
  }

  return (
    <FormGroup className={clsx("choices", "checkbox")}>
      {options.map((option, index) => {
        return (
          <FormControlLabel
            key={index}
            control={<Checkbox checked={option.correct} onChange={e => handleChange(index, e.target.checked)} />}
            label={<div className="choice-caption" dangerouslySetInnerHTML={{__html: option.html || ''}} />}
          />
        )})}
    </FormGroup>
  )
}
